import api from '../../../../services/api';

const CRM_BASE = '/crm';

export const listCrmClientes = (params = {}) =>
  api.get(`${CRM_BASE}/clientes`, { params }).then((response) => response.data);

export const getCrmClientePerfil = (telefone, params = {}) =>
  api
    .get(`${CRM_BASE}/clientes/perfil`, { params: { ...params, telefone } })
    .then((response) => response.data);

export const getCrmPedidoDetalhes = (pedidoId, params = {}) =>
  api
    .get(`${CRM_BASE}/pedidos/${encodeURIComponent(pedidoId)}/detalhes`, { params })
    .then((response) => response.data);

export const listCrmClienteEnderecos = (telefone) =>
  api
    .get(`${CRM_BASE}/clientes/enderecos`, { params: { telefone } })
    .then((response) => response.data);

export const getCrmResumo = () =>
  api.get(`${CRM_BASE}/resumo`).then((response) => response.data);

// Reaproveita a rota do Feedback Hero para saber quais feedbacks negativos
// já foram marcados como "atendido". `pendencia=atendida` retorna apenas esses
// (mesma tabela/`id` usados pelo CRM), sem paginação quando não passamos page.
export const listFeedbacksAtendidos = () =>
  api
    .get('/feedback/feedbacks', { params: { pendencia: 'atendida' } })
    .then((response) => {
      const payload = response.data;
      if (Array.isArray(payload)) return payload;
      return Array.isArray(payload?.data) ? payload.data : [];
    });
